import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyAssignAdminService {

  constructor(private httpClient: HttpClient) { }

  getAssignedAdminDocuments(isActive: boolean) : Observable<any>{
    return this.httpClient.get(ApiConstants.MyAssignAdmin + isActive);
  }
}
